import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Icon = styled.img`
  width: ${({ $size = 16 }) => $size}px;
  height: ${({ $size = 16 }) => $size}px;
  flex-shrink: 0;
`;

export const EventContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
